import { Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { PhoneList } from '../models';
import { PhoneService } from '../services';
import { Phone } from '../models/index';
import { Variant } from '../models/index';

// TODO unsubscribe obs and add change detection on push
@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, OnDestroy {
  @Input() btnName: string;
  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  private sub;
  searchForm: FormGroup;
  brand: FormControl;
  phone: FormControl;
  variant: FormControl;
  brands: any;
  phones: Phone[] = [];
  variants: Variant[] = [];

  constructor (private builder: FormBuilder, private phoneService: PhoneService) {}

  search ($event) {
    $event.preventDefault();
    // console.log(this.searchForm.value, this.searchForm.valid);
    if (this.searchForm.valid) {
      const brandId = this.searchForm.value.brand.id;
      const phoneId = this.searchForm.value.phone.id;
      const variantId = this.searchForm.value.variant.id;
      localStorage.setItem('brandId', brandId);
      localStorage.setItem('phoneId', phoneId);
      localStorage.setItem('variantId', variantId);
      // console.log(this.searchForm.value.brand, this.searchForm.value.phone, this.searchForm.value.variant);
      this.onSearch.emit({
        brand: this.searchForm.value.brand,
        phone: this.searchForm.value.phone,
        variant: this.searchForm.value.variant
      });
    }
  }

  initForm () {
    this.brand = new FormControl('', [Validators.required]);
    this.phone = new FormControl('', []);
    this.variant = new FormControl('', []);
    this.searchForm = this.builder.group({
      brand: this.brand,
      phone: this.phone,
      variant: this.variant
    });
  }

  _initFormListener() {
    // this.searchForm.valueChanges
    //   .subscribe(values => {
    //     // console.log(values);
    //   });
    this.brand.valueChanges
      .subscribe(val => {
        // console.log(val);
        if (val) {
          this.phones = <Array<Phone>>Array.from(val.phones.values());
          // this.phone.setValue(this.phones[0]);
        } else {
          this.phones = [];
          this.variants = [];
        }
        this.phone.setValue('');
        this.variant.setValue('');
      });

    this.phone.valueChanges
      .subscribe(val => {console.log(val);
        if (val) {
          this.variants = <Array<Variant>>Array.from(val.variants.values());
          // this.variant.setValue(this.variants[0]);
        } else {
          this.variants = [];
        }
        this.variant.setValue('');
      });
  }

  _setStoredPhone() {
    const brandId = localStorage.getItem('brandId');
    const phoneId = localStorage.getItem('phoneId');
    const variantId = localStorage.getItem('variantId');
    // console.log(phoneId, brandId, variantId);
    this.sub = this.phoneService.obs.phoneList
      .subscribe((phoneList: PhoneList) => {
        // Set the brand list
        this.brands = Array.from(phoneList.brands.values());

        let brand, phone, variant;
        brand = phoneList.brands.get(brandId);
        if (brand) {
          this.brand.setValue(brand);
          phone = brand.phones.get(phoneId);

          if (phone) {
            this.phone.setValue(phone);
            variant = phone.variants.get(variantId);

            if (variant) {
              this.variant.setValue(variant);
            }
          }
        }
      });
  }

  ngOnInit() {
    this.initForm();
    this._initFormListener();
    this._setStoredPhone();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/search-bar/search-bar.component.ts